import type { RootState } from 'store';
import type { Interview, InterviewFeedback } from 'store/reducers/jobReducer';
import type { Uuid } from 'store/reducers/types';
import { getCurrentInterview, groupFeedbacksByInterview, type InterviewFeedbackGroup } from 'constants/interview';

const EMPTY_INTERVIEWS: Interview[] = [];
const EMPTY_INTERVIEW: Interview = {};
const EMPTY_FEEDBACKS: InterviewFeedback[] = [];
const EMPTY_FEEDBACK_GROUPS: InterviewFeedbackGroup[] = [];

export const getJobListFilters = (state: RootState) => state.job.filter;
export const getJobData = (state: RootState) => state.job.jobData;
export const getOpeningsList = (state: RootState) => state.job.openingsList;
export const getOpeningCandidate = (state: RootState) => state.job.openingCandidate;
export const getJobSteps = (state: RootState) => state.job.steps;
export const getRooms = (state: RootState) => state.job.rooms;
export const getJobCandidates = (state: RootState) => state.job.candidates;
export const getIsCandidateExistsOnJob = (state: RootState) => state.job.isCandidateExistsOnJob;
export const getJobLoader = (state: RootState) => state.job.loader;
export const getJobCandidateDataLoading = (state: RootState) => state.job.candidateDataLoading;
export const getJobApprovers = (state: RootState) => state.job.approversCandidate;
export const getJobApproversLoading = (state: RootState) => state.job.approversCandidateLoading;
export const getJobCVS = (state: RootState) => state.job.cvs;
export const getJobCVSLinks = (state: RootState) => state.job.cvsLinks;
export const getJobUserData = (state: RootState) => state.job.userData;
export const getJobAssignmentId = (state: RootState) => state.job.jobAssignmentId;
export const getJobScorecard = (state: RootState) => state.job.scorecard;
export const getJobInterviews = (stepId: Uuid) => (state: RootState) =>
  state.job.interviewsByStep[stepId] || EMPTY_INTERVIEWS;
export const getPrimaryJobInterview = (stepId: Uuid) => (state: RootState) => {
  const interviews = state.job.interviewsByStep[stepId] || EMPTY_INTERVIEWS;
  return getCurrentInterview(interviews) || EMPTY_INTERVIEW;
};
export const getCurrentJobInterview = getPrimaryJobInterview;
export const getInterviewFeedbacks = (stepId: Uuid) => (state: RootState) =>
  state.job.feedbacksByStep[stepId] || EMPTY_FEEDBACKS;
export const getInterviewFeedbackGroups =
  (stepId: Uuid) =>
  (state: RootState): InterviewFeedbackGroup[] => {
    const interviews = state.job.interviewsByStep[stepId] || EMPTY_INTERVIEWS;
    const feedbacks = state.job.feedbacksByStep[stepId] || EMPTY_FEEDBACKS;
    if (!interviews.length && !feedbacks.length) return EMPTY_FEEDBACK_GROUPS;
    return groupFeedbacksByInterview(feedbacks, interviews);
  };
export const getInterviewFeedbacksLoading = (stepId: Uuid) => (state: RootState) =>
  !!state.job.feedbacksLoadingByStep[stepId];
export const getJobInterviewLoading = (stepId: Uuid) => (state: RootState) =>
  !!state.job.interviewsLoadingByStep[stepId];
export const getJobOffering = (state: RootState) => state.job.offeringCandidate;
export const getJobOfferingLoading = (state: RootState) => state.job.offeringCandidateLoading;
export const getJobOfferRecommendation = (state: RootState) => state.job.offerRecommendation;
export const getJobProbationPeriod = (state: RootState) => state.job.probationPeriod;
export const getJobEntryDateLoading = (state: RootState) => state.job.entryDateLoading;
export const getJobActivityListLoading = (state: RootState) => state.job.activityListLoading;
export const getJobTimelineCommentLoading = (state: RootState) => state.job.timelineCommentLoading;
export const getTimelineLoading = (state: RootState) => state.job.timelineLoading;
export const getTodaysInterviews = (state: RootState) => state.job.todaysInterviews;
export const getCandidateSummary = (state: RootState) => state.job.candidateSummary;
